import React from 'react';
import FAQ from './faq';
import { hjemmesideFAQData } from '../data/faqData';

const HjemmesideFAQ = () => {
  return (
    <FAQ 
      faqData={hjemmesideFAQData}
      title="Ofte stillede spørgsmål om hjemmesider"
      subtitle="Alt hvad du skal vide om at få lavet en professionel hjemmeside. Har du andre spørgsmål? Kontakt os for en snak."
      className="faq-hjemmeside"
      showCTA={true}
    />
  );
};

export default HjemmesideFAQ;